module.exports = __webpack_public_path__ + "img/mexico862.75249741.jpg";